import { render, staticRenderFns } from "./offlineOrderDet.vue?vue&type=template&id=237daba0&scoped=true"
import script from "./offlineOrderDet.vue?vue&type=script&lang=js"
export * from "./offlineOrderDet.vue?vue&type=script&lang=js"
import style0 from "./offlineOrderDet.vue?vue&type=style&index=0&id=237daba0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237daba0",
  null
  
)

export default component.exports